export default "__VITE_ASSET__DDKiPpX2__"